var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInvitationUser = function SvgIconInvitationUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38 17.567-28 .008L7 20v3h34v-3l-3-2.433Z",
    fill: "#FFAD24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 7H11a1 1 0 0 0-1 1v23a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Z",
    fill: "#FFFAEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.848 31.185 7 20v19a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V20L25.152 31.185a2.003 2.003 0 0 1-2.307 0h.003Z",
    fill: "#FFC82A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.003 17.55a2.775 2.775 0 1 0 0-5.55 2.775 2.775 0 0 0 0 5.55ZM27.918 23.5h-7.833c-.83 0-1.445-.798-1.203-1.593.673-2.185 2.71-3.645 5.12-3.645s4.448 1.46 5.12 3.645c.245.793-.372 1.593-1.202 1.593h-.003Z",
    fill: "#FFAD24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.678 27.168 7.623 40.448c.36.342.845.555 1.38.555h30c.535 0 1.02-.213 1.38-.555L25.325 27.17a1.997 1.997 0 0 0-2.645 0l-.002-.002Z",
    fill: "#FFDA67"
  })));
};
export default SvgIconInvitationUser;